const translations = {
    save: 'save'
};

export default translations;
